import { GET_DEPLOYMENT_PAGE_AGENTS_DATA } from '../types/deployment';

export const deploymentReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DEPLOYMENT_PAGE_AGENTS_DATA:
      return getDeploymentPageAgentsData(state, action);
    default:
      return state;
  }
};

function getDeploymentPageAgentsData(state, action) {
  const { data } = action.payload;
  const deployData = data;
  let result = '';
  if (deployData.length > 0) {
    result = deployData;
  } else {
    result = [];
  }
  return result;
}
